export var WarehouseOutwardKeys = {
    transporterList: "TransporterList",
    shippingMethodList: "ShippingMethodList",
    transferRequisitionList: "TransferRequisitionList",
    warehouseList: "warehouseListGet",
    TransportList: "getTransportList",
    paging: "WarehouseOutwardPaging",
    ItemsPaging: "WOItemsPagingAPI",
    create: "warehouseOutwardCreate",
    get: 'WarehouseGetById',
    AttachmentSystemName: "warehouseOutwardattachment",
    UploadAttachment: "uploadAttachment",
    WrOutwardGet: "WarehouseOutwardGet"
};
export var showColumnName = {
    SrNo: "Sr no",
    IWONumber: "IWO number",
    TransferDate: "Transfer Date",
    CreatedOn: "Created by",
    CreatedDate: "Created date",
    SourceWarehouseName: "Source warehouse",
    DestinationWarehouse: "Destination warehouse",
    TransporterName: "Transporter name",
    ShippingMethod: "Shipping method",
    TotalQuantity: "Total qty",
    actions: "actions"
};
